// extracted by mini-css-extract-plugin
export const mainContainer = "Styles-module--mainContainer--15R5-";
export const titleContainer = "Styles-module--titleContainer--S8BTI";
export const title = "Styles-module--title--x4yhN";